// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon, ButtonFilled, Box } from 'Components/Base';
import { ClearAttachment, AttachmentContent } from 'Components/Classroom/Clear';
import { useFaqTracking } from 'Util/Analytics/useFaqTracking';

import ClearByOnDemand from '../ClearByOnDemand';

import AttachmentFeedback from './AttachmentFeedback';

const ATTACHMENT_HEADER = {
  title: 'คำถามที่พบบ่อย',
  description: 'ข้อสงสัยที่เพื่อนๆมักถามผ่านระบบ CLEAR และพี่สรุปมาให้อ่านเข้าใจง่าย',
  icon: SvgIcon.ICON_LIST.QUESTION_CIRCLE_FILL,
};

const ClearPlusFooter = (props) => {
  const { logOpenClear } = useFaqTracking();

  return (
    <Box
      bottom={0}
      padding={6}
      width={'100%'}
      backgroundColor={'white'}
      style={{ boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)' }}
      {...props}
    >
      <ClearByOnDemand
        renderButton={(onClick) => (
          <ButtonFilled
            onClick={() => {
              logOpenClear();
              onClick();
            }}
            width={1}
            color={'clear.clearDark'}
          >
            <SvgIcon icon={SvgIcon.ICON_LIST.QUESTION_MARK_PERSON_ICON} mr={2} />
            {'ถาม CLEAR กับนักวิชาการ'}
          </ButtonFilled>
        )}
      />
    </Box>
  );
};

function Attachment({
  attachments,
  attachmentSelected,
  backToAttachmentList,
  setAttachmentSelected,
  loading,
}) {
  return (
    <>
      <Box overflow={'auto'} flexGrow={1} padding={6}>
        {attachmentSelected ? (
          <>
            <AttachmentContent
              title={attachmentSelected.title}
              detail={attachmentSelected.detail}
              backToAttachmentList={backToAttachmentList}
            />
            <AttachmentFeedback attachment={attachmentSelected} />
          </>
        ) : (
          <ClearAttachment
            attachments={attachments}
            setAttachmentSelected={setAttachmentSelected}
            attachmentHeader={ATTACHMENT_HEADER}
            isLoading={loading}
          />
        )}
      </Box>
      <ClearPlusFooter />
    </>
  );
}

Attachment.propTypes = {
  backToAttachmentList: PropTypes.func,
  setAttachmentSelected: PropTypes.func,
  loading: PropTypes.bool,
};

export default Attachment;
